function alwaysValid() {
    return true;
}
function noCompose() { }
// tslint:disable:no-parameter-reassignment
function ensureProtocolOptions(initialOptions) {
    let options = initialOptions;
    if (options === undefined) {
        options = {};
    }
    else if (typeof options === 'function') {
        options = {
            validate: options,
        };
    }
    if (!options.validate) {
        options.validate = alwaysValid;
    }
    if (!options.compose) {
        options.compose = noCompose;
    }
    return options;
}
function createProtocolValidator(validate) {
    return (target) => {
        const result = validate(target);
        return result === true;
    };
}
function createProtocolAsserter(name, validate) {
    return (target) => {
        const result = validate(target);
        if (result !== true) {
            throw new Error(result || `${name} was not correctly implemented.`);
        }
    };
}
/**
 * Decorator: Creates a protocol.
 * @param name The name of the protocol.
 * @param options The validation function or options object used in configuring the protocol.
 */
export const protocol = function protocol(name, initialOptions) {
    const options = ensureProtocolOptions(initialOptions);
    // tslint:disable-next-line:only-arrow-functions
    const result = function (target) {
        const resolvedTarget = typeof target === 'function' ? target.prototype : target;
        options.compose(resolvedTarget);
        result.assert(resolvedTarget);
        Object.defineProperty(resolvedTarget, 'protocol:' + name, {
            enumerable: false,
            configurable: false,
            writable: false,
            value: true,
        });
    };
    result.validate = createProtocolValidator(options.validate);
    result.assert = createProtocolAsserter(name, options.validate);
    return result;
};
/**
 * Creates a protocol decorator.
 * @param name The name of the protocol.
 * @param options The validation function or options object used in configuring the protocol.
 * @return The protocol decorator;
 */
// tslint:disable-next-line:only-arrow-functions
protocol.create = function (name, initialOptions) {
    const options = ensureProtocolOptions(initialOptions);
    const hidden = 'protocol:' + name;
    // tslint:disable-next-line:only-arrow-functions
    const result = function (target) {
        const decorator = protocol(name, options);
        return target ? decorator(target) : decorator;
    };
    result.decorates = ((obj) => obj[hidden] === true);
    result.validate = createProtocolValidator(options.validate);
    result.assert = createProtocolAsserter(name, options.validate);
    return result;
};
//# sourceMappingURL=data:application/json;base64,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